import { api, apiEndPoints, addActionLoader, removeActionLoader } from 'api';

import {
  SET_API_ERROR,
  CLIENT_BANNER_REQUEST,
  GET_BUY_AGAIN_REQUEST,
  GET_BUYER_DETAILS_REQUEST,
  GET_PRODUCT_COLLECTION_LIST_REQUEST,
  UPDATE_NOTIFICATION_BAR,
} from './constants';

const setApiError = (error) => ({
  type: SET_API_ERROR,
  payload: error,
});

export const getClientBanner = (successCallBack) => async (dispatch) => {
  try {
    dispatch(addActionLoader(CLIENT_BANNER_REQUEST));

    const response = await api.get(apiEndPoints.clientBanner);
    const { data } = response;

    if (response.status === 200 || data.status) {
      return successCallBack(data);
    }
    return data;
  } catch (error) {
    dispatch(setApiError(error));
    return false;
  } finally {
    dispatch(removeActionLoader(CLIENT_BANNER_REQUEST));
  }
};

export const getHomePageProducts = (queryParams) => async (dispatch) => {
  try {
    dispatch(addActionLoader(GET_BUY_AGAIN_REQUEST));

    const response = await api.get(apiEndPoints.homePageProducts(queryParams));
    const { data } = response;

    if (response.status === 200 || data.status) {
      return data?.data ?? {};
    }
    return false;
  } catch (error) {
    dispatch(setApiError(error));
    return false;
  } finally {
    dispatch(removeActionLoader(GET_BUY_AGAIN_REQUEST));
  }
};

export const getBuyerDetails = (payload) => async (dispatch) => {
  try {
    dispatch(addActionLoader(GET_BUYER_DETAILS_REQUEST));

    const response = await api.get(
      `/buyers?page=${payload?.page}&limit=50&search=${payload?.search}&filters=&templateId=`
    );
    const { data } = response;
    if (response.status === 200 || data.status) {
      return data?.data ?? [];
    }
    return false;
  } catch (error) {
    dispatch(setApiError(error));
    return false;
  } finally {
    dispatch(removeActionLoader(GET_BUYER_DETAILS_REQUEST));
  }
};

export const getProductCollectionListDetails =
  (payload) => async (dispatch) => {
    try {
      dispatch(addActionLoader(GET_PRODUCT_COLLECTION_LIST_REQUEST));

      const response = await api.get(apiEndPoints?.getProductCollectionList);
      const { data } = response;

      if (response.status === 200 || data.status) {
        return data?.data ?? [];
      }
      return false;
    } catch (error) {
      dispatch(setApiError(error));
      return false;
    } finally {
      dispatch(removeActionLoader(GET_PRODUCT_COLLECTION_LIST_REQUEST));
    }
  };

export const updateNotificationBar = (payload) => async (dispatch) => {
  try {
    dispatch(addActionLoader(`${UPDATE_NOTIFICATION_BAR}_${payload?.id}`));
    const response = await api.post(
      apiEndPoints?.updateNotificationBar,
      payload
    );
    const { data: { status = false, message = '' } = {} } = response;
    if (status) {
      return status;
    }
    return false;
  } catch (error) {
    dispatch(setApiError(error));
    return false;
  } finally {
    dispatch(removeActionLoader(`${UPDATE_NOTIFICATION_BAR}_${payload?.id}`));
  }
};
